var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDev = function SvgDev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8885 10.9702C11.1877 10.9702 11.4876 11.083 11.7867 11.3085C12.085 11.534 12.2354 11.8732 12.2361 12.3242V17.7408C12.2361 18.1926 12.0866 18.5309 11.7874 18.7565C11.4883 18.982 11.1884 19.0947 10.8893 19.0947H9.54405V10.9702H10.8885Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97826 0C1.60955 0 0.5 1.11928 0.5 2.5V27.5C0.5 28.8807 1.60955 30 2.97826 30H36.0217C37.3904 30 38.5 28.8807 38.5 27.5V2.5C38.5 1.11928 37.3904 0 36.0217 0H2.97826ZM10.6858 21.4301C13.5189 21.4348 14.414 19.2184 14.414 17.7556L14.4132 12.2394C14.4124 10.7758 13.4935 8.56252 10.7613 8.56252H7.1087V21.4301H10.6858ZM18.0682 10.8605H22.1756L22.1764 8.56486H17.3049C16.4454 8.58663 15.7647 9.30679 15.7855 10.1738V19.9035C15.807 20.7714 16.5224 21.4574 17.3829 21.4348H22.1764V19.1352H18.0682V16.1481H20.5791V13.8485H18.0682V10.8605ZM26.5082 19.8265C27.3247 21.742 29.1479 22.218 30.1655 19.8265L33.1304 8.56562H30.6188L28.3392 17.4095L26.0488 8.56562H23.5379L26.5082 19.8265Z",
    fill: "#ADB5BD"
  })));
};
export default SvgDev;